import { Component, OnInit } from '@angular/core';
import { FrontUserService } from '../../../../core/services/frontUsers.service';
import { FuseConfigService } from '../../../../core/services/config.service';
import { OrganizationsService } from '../../../../core/services/organizations.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {FuseMailDialogComponent} from '../../../../core/components/mail-dialog/mail-dialog.component';
import { DocumentsService } from '../../../../core/services/documents.service';

@Component({
    selector: 'importUser-modal',
    templateUrl: './importUser.component.html',
    styleUrls: ['./importUser.component.scss'],
    standalone: false
})

export class ImportUserComponent implements OnInit {

  csvContent: string;
  importError = [];
  importedUser = [];
  targetGroups = [];
  targetShow = [];
  countries = [];
  cantons = [];
  organizations = [];
  roles = [];
  roleValue = 0;
  isOrganizer = false;
  isCanton = false;
  isCountry = false;
  isSuper = false;

  userCount = 0;
  uploadedUser = 0;
  notUploadedUser = 0;
  procent: any = 0;
  fileUrl;

  form: FormGroup = new FormGroup({
    country: new FormControl('', Validators.required),
    canton: new FormControl('', Validators.required),
    organization: new FormControl('', Validators.required),
    role: new FormControl('', Validators.required),
    target: new FormControl('', Validators.required)
  });


  constructor(private usersService: FrontUserService, private fuseConfig: FuseConfigService, private dialog: MatDialog,
              public documentsService: DocumentsService,
              private organizationService: OrganizationsService, public dialogRef: MatDialogRef<ImportUserComponent>) {
    this.fuseConfig.role.subscribe(res => {
      if (res && res === 'organisationAdmin') {
        this.isOrganizer = true;
        this.isCanton = false;
        this.isCountry = false;
        this.isSuper = false;
      }
      if (res && res === 'subCountryAdmin') {
        this.isCanton = true;
        this.isOrganizer = false;
        this.isCountry = false;
        this.isSuper = false;
      }
      if (res && res === 'countryAdmin') {
        this.isCountry = true;
        this.isCanton = false;
        this.isSuper = false;
        this.isOrganizer = false;
      }
      if (res && res === 'superAdmin') {
        this.isSuper = true;
        this.isCanton = false;
        this.isOrganizer = false;
        this.isCountry = false;
      }
    });
  }

  getFileUrl() {
    this.documentsService.getFiles('files/Book.csv').subscribe((res: any) => {
      if (res && res.url) {
        this.fileUrl = res.url;
      }
    });
  }


  ngOnInit() {
    this.getFileUrl();
    this.getTargetGroups();
    this.getRoles();
    this.getCountries();
    this.form.get('country').valueChanges.subscribe(res => {
      this.getCantons(res);
    });
    this.form.get('canton').valueChanges.subscribe(res => {
      this.getOrganizations(res);
    });

    this.form.get('role').valueChanges.subscribe(res => {
      this.roleValue = res;
      if (this.roleValue !== 1) {
        this.form.controls['target'].setValidators([]);
      } else {
        this.form.controls['target'].setValidators([Validators.required]);
      }
      this.form.patchValue({target: null});
    });
  }

  parseFile(file) {
    let listArray = file.split('\n');
    listArray.shift();
    listArray = listArray.filter(x => x);
    if (listArray.length) {
      this.userCount = listArray.length;
      const dialogRef = this.dialog.open(FuseMailDialogComponent, {
        panelClass: 'unsave-form-dialog'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          let sendInvite;
          if (result === 'yes') {
            sendInvite = true;
          }
          if (result === 'no') {
            sendInvite = false;
          }
          for (let l = 0; l < listArray.length; l++) {
            let position = l + 1;
            let phoneError = false;
            if (listArray[l]) {
              let row = listArray[l];
              let duplicateRows = listArray.filter(el => el.indexOf(row) !== -1);
              if (duplicateRows.length > 1) {
                this.notUploadedUser = this.notUploadedUser + 1;
                this.procent = Number(this.procent) + (Number((100 / this.userCount).toFixed()));
                this.importError.push({position: +position + 1, errorMsg: 'row_error_duplicate'});
                continue;
              }
              let user = listArray[l].split(';');
              if (user[3]) {
                let duplicateEmails = listArray.filter(el => el.indexOf(';' + user[3] + ';') !== -1);
                if (duplicateEmails.length > 1) {
                  this.notUploadedUser = this.notUploadedUser + 1;
                  this.procent = Number(this.procent) + (Number((100 / this.userCount).toFixed()));
                  this.importError.push({position: +position + 1, errorMsg: 'email_error_duplicate', email:  user[3]});
                  continue;
                }
              }
              if (user[0] && user[1]) {
                let _dateOfBirdth;
                if (user[11]){
                  // let _dates = user[11].split('.');
                  // if (_dates.length === 3) {
                  //   _dateOfBirdth = new Date(_dates[2] + '/' + _dates[1] + '/' + _dates[0]);
                  // }
                  _dateOfBirdth = user[11];
                }
                let _dateOfBaptism;
                if (user[13]){
                  // let _dates = user[13].split('.');
                  // if (_dates.length === 3) {
                  //   _dateOfBaptism = new Date(_dates[2] + '/' + _dates[1] + '/' + _dates[0]);
                  // }
                  _dateOfBaptism = user[13];
                }
                if (user[9]) {
                  user[9] = user[9].replace(/_/g, '').replace(/ /g, '').slice(0 , 14);
                  user[9] = user[9].substring(0, 3) + ' ' + user[9].substring(3, 5) + ' ' + user[9].substring(5, user[9].length);
                  let checkPhone = user[9].replace(/\+/g, '').replace(/ /g, '');
                  if (!checkPhone) {
                    user[9] = '';
                  }
                }
                if (user[10]) {
                  user[10] = user[10].replace(/_/g, '').replace(/ /g, '').slice(0 , 14);
                  user[10] = user[10].substring(0, 3) + ' ' + user[10].substring(3, 5) + ' ' + user[10].substring(5, user[10].length);
                  let checkMobile = user[10].replace(/\+/g, '').replace(/ /g, '');
                  if (!checkMobile) {
                    user[10] = '';
                  }
                }
                if (user[9] && (user[9].length < 14 || user[9].indexOf('+') !== 0)) {
                  this.notUploadedUser = this.notUploadedUser + 1;
                  this.procent = Number(this.procent) + (Number((100 / this.userCount).toFixed()));
                  this.importError.push({position: +position + 1, errorMsg: 'phone_error'});
                  phoneError = true;
                } else if (user[10] && (user[10].length < 14 || user[10].indexOf('+') !== 0)) {
                  this.notUploadedUser = this.notUploadedUser + 1;
                  this.procent = Number(this.procent) + (Number((100 / this.userCount).toFixed()));
                  this.importError.push({position: +position + 1, errorMsg: 'mobile_error'});
                  phoneError = true;
                }
                if (!phoneError){
                  if (user[3]) {
                    this.usersService.checkEmailValid(user[3]).subscribe((res: any) => {
                      if (res && !res.user) {
                        let userObj = {
                          frontRoleId: this.form.value.role,
                          firstName: user[0],
                          lastName: user[1],
                          nickName: user[2],
                          email: user[3],
                          gender: user[4],
                          street: user[5],
                          number: user[6],
                          postcode: user[7],
                          cityLocation: user[8],
                          phone: user[9],
                          mobile: user[10],
                          dateOfBirth: _dateOfBirdth,
                          abschlussjahr: user[12],
                          dateOfBaptism: _dateOfBaptism,
                          sendInvite: sendInvite,
                          countryId: this.form.value.country,
                          cityId: this.form.value.canton,
                          organizationId: this.form.value.organization,
                          targetGroupId: this.form.value.target,
                          isMember: true,
                          importedTags: user[14]
                        };
                        this.addUser(userObj, position);
                      } else {
                        this.notUploadedUser = this.notUploadedUser + 1;
                        this.procent = Number(this.procent) + (Number((100 / this.userCount).toFixed()));
                        this.importError.push({position: +position + 1, errorMsg: 'email_error', email:  user[3]});
                      }
                    });
                  } else {
                    let userObj = {
                      frontRoleId: this.form.value.role,
                      firstName: user[0],
                      lastName: user[1],
                      nickName: user[2],
                      email: user[3],
                      gender: user[4],
                      street: user[5],
                      number: user[6],
                      postcode: user[7],
                      cityLocation: user[8],
                      phone: user[9],
                      mobile: user[10],
                      dateOfBirth: _dateOfBirdth,
                      abschlussjahr: user[12],
                      dateOfBaptism: _dateOfBaptism,
                      sendInvite: sendInvite,
                      countryId: this.form.value.country,
                      cityId: this.form.value.canton,
                      organizationId: this.form.value.organization,
                      targetGroupId: this.form.value.target,
                      isMember: true,
                      importedTags: user[14]
                    };
                    this.addUser(userObj, position);
                  }
                }
              } else {
                this.notUploadedUser = this.notUploadedUser + 1;
                this.procent = Number(this.procent) + (Number((100 / this.userCount).toFixed()));
                this.importError.push({position: +position + 1, errorMsg: 'req_field_error'});
              }
            }
          }
          // listArray.forEach((el, index) => {
          //   let position = index + 1;
          //   let phoneError = false;
          //   if (el) {
          //     let user = el.split(';');
          //     if (user[0] && user[1]) {
          //       let _dateOfBirdth;
          //       if (user[11]){
          //         let _dates = user[11].split('.');
          //         if (_dates.length === 3) {
          //           _dateOfBirdth = new Date(_dates[2] + '/' + _dates[1] + '/' + _dates[0]);
          //         }
          //       }
          //       let _dateOfBaptism;
          //       if (user[13]){
          //         let _dates = user[13].split('.');
          //         if (_dates.length === 3) {
          //           _dateOfBaptism = new Date(_dates[2] + '/' + _dates[1] + '/' + _dates[0]);
          //         }
          //       }
          //       if (user[9]) {
          //         user[9] = user[9].replace(/_/g, '').replace(/ /g, '').slice(0 , 14);
          //         user[9] = user[9].substring(0, 3) + ' ' + user[9].substring(3, 5) + ' ' + user[9].substring(5, user[9].length);
          //         let checkPhone = user[9].replace(/\+/g, '').replace(/ /g, '');
          //         if (!checkPhone) {
          //           user[9] = '';
          //         }
          //       }
          //       if (user[10]) {
          //         user[10] = user[10].replace(/_/g, '').replace(/ /g, '').slice(0 , 14);
          //         user[10] = user[10].substring(0, 3) + ' ' + user[10].substring(3, 5) + ' ' + user[10].substring(5, user[10].length);
          //         let checkMobile = user[10].replace(/\+/g, '').replace(/ /g, '');
          //         if (!checkMobile) {
          //           user[10] = '';
          //         }
          //       }
          //       if (user[9] && (user[9].length < 14 || user[9].indexOf('+') !== 0)) {
          //         this.notUploadedUser = this.notUploadedUser + 1;
          //         this.procent = Number(this.procent) + (Number((100 / this.userCount).toFixed()));
          //         this.importError.push({position: +position + 1, errorMsg: 'phone_error'});
          //         phoneError = true;
          //       } else if (user[10] && (user[10].length < 14 || user[10].indexOf('+') !== 0)) {
          //         this.notUploadedUser = this.notUploadedUser + 1;
          //         this.procent = Number(this.procent) + (Number((100 / this.userCount).toFixed()));
          //         this.importError.push({position: +position + 1, errorMsg: 'mobile_error'});
          //         phoneError = true;
          //       }
          //       if (!phoneError){
          //         if (user[3]) {
          //           this.usersService.checkEmailValid(user[3]).subscribe((res: any) => {
          //             if (res && !res.user) {
          //               let userObj = {
          //                 frontRoleId: this.form.value.role,
          //                 firstName: user[0],
          //                 lastName: user[1],
          //                 nickName: user[2],
          //                 email: user[3],
          //                 gender: user[4],
          //                 street: user[5],
          //                 number: user[6],
          //                 postcode: user[7],
          //                 cityLocation: user[8],
          //                 phone: user[9],
          //                 mobile: user[10],
          //                 dateOfBirth: _dateOfBirdth,
          //                 abschlussjahr: user[12],
          //                 dateOfBaptism: _dateOfBaptism,
          //                 sendInvite: sendInvite,
          //                 countryId: this.form.value.country,
          //                 cityId: this.form.value.canton,
          //                 organizationId: this.form.value.organization,
          //                 targetGroupId: this.form.value.target,
          //                 isMember: true
          //               };
          //               this.addUser(userObj, position);
          //             } else {
          //               this.notUploadedUser = this.notUploadedUser + 1;
          //               this.procent = Number(this.procent) + (Number((100 / this.userCount).toFixed()));
          //               this.importError.push({position: +position + 1, errorMsg: 'email_error', email:  user[3]});
          //             }
          //           });
          //         } else {
          //           let userObj = {
          //             frontRoleId: this.form.value.role,
          //             firstName: user[0],
          //             lastName: user[1],
          //             nickName: user[2],
          //             email: user[3],
          //             gender: user[4],
          //             street: user[5],
          //             number: user[6],
          //             postcode: user[7],
          //             cityLocation: user[8],
          //             phone: user[9],
          //             mobile: user[10],
          //             dateOfBirth: _dateOfBirdth,
          //             abschlussjahr: user[12],
          //             dateOfBaptism: _dateOfBaptism,
          //             sendInvite: sendInvite,
          //             countryId: this.form.value.country,
          //             cityId: this.form.value.canton,
          //             organizationId: this.form.value.organization,
          //             targetGroupId: this.form.value.target,
          //             isMember: true
          //           };
          //           this.addUser(userObj, position);
          //         }
          //       }
          //     } else {
          //       this.notUploadedUser = this.notUploadedUser + 1;
          //       this.procent = Number(this.procent) + (Number((100 / this.userCount).toFixed()));
          //       this.importError.push({position: +position + 1, errorMsg: 'req_field_error'});
          //     }
          //   }
          // });
        }
      });

    }
  }

  addUser(user, position) {
    this.usersService.addUser(user).subscribe((res: any) => {
      if (res) {
        if (res.msg === 'wrongEmail') {
          this.notUploadedUser = this.notUploadedUser + 1;
          this.procent = Number(this.procent) + (Number((100 / this.userCount).toFixed()));
          this.importError.push({position: +position + 1, errorMsg: 'wrong_email'});
        } else {
          this.uploadedUser = this.uploadedUser + 1;
          this.procent = Number(this.procent) + (Number((100 / this.userCount).toFixed()));
          this.importedUser.push({user: user.firstName + ' ' + user.lastName});
        }
      }
    }, error => {
      this.notUploadedUser = this.notUploadedUser + 1;
      this.procent = Number(this.procent) + (Number((100 / this.userCount).toFixed()));
      this.importError.push({position: +position + 1, errorMsg: 'req_field_error'});
    });
  }


  getTargetGroups() {
    this.usersService.getTargetGroup().subscribe((targetResults: any) => {
      this.targetGroups = [];
      for (let i = 0; i < targetResults.targetGroups.length; i++) {
        this.targetGroups.push({
          value: targetResults.targetGroups[ i ].id ,
          label: ((('0' + targetResults.targetGroups[ i ].targetNumber).slice(-2)) + ' - ' + targetResults.targetGroups[ i ].ageMask),
          number: targetResults.targetGroups[ i ].targetNumber
        });
      }
    });
  }

  getRoles() {
    this.usersService.getRoles().subscribe((rolesRes: any) => {
      for (let i = 0; i < rolesRes.length; i++) {
        this.roles.push({value: rolesRes[ i ].id , label: rolesRes[ i ].name});
      }
    });
  }

  getCountries () {
    this.organizationService.getCountry().subscribe((res: any) => {
      if (res.length > 1) {
        this.countries = res;
      } else if (res.length === 1) {
        this.form.patchValue({country: res[ 0 ].id});
      } else {
        this.countries = [];
      }
    });
  }

  getCantons (id) {
    this.organizationService.getCity(id).subscribe((res: any) => {
      if (res.length > 1) {
        this.cantons = res;
      } else if (res.length === 1) {
        this.form.patchValue({canton: res[ 0 ].id});
      } else {
        this.cantons = [];
      }
    });
  }

  getOrganizations (id) {
    this.usersService.getOrganizationByCantonId(id).subscribe((res: any) => {
      if (res.length > 1) {
        this.organizations = res;
      } else if (res.length === 1) {
        this.organizations = res;
        this.form.patchValue({organization: res[ 0 ].id});
      } else {
        this.organizations = [];
      }
    });
  }

  onFileSelect(input: HTMLInputElement) {
    if (this.form.valid) {
      this.uploadedUser = 0;
      this.procent = 0;
      this.notUploadedUser = 0;
      this.importError = [];
      this.importedUser = [];

      const files = input.files;
      let content = this.csvContent;
      if (files && files.length) {

        const fileToRead = files[0];

        const fileReader = new FileReader();
        const that = this;
        fileReader.onload = function (e: any) {
          const textFromFileLoaded = e.target.result;
          that.csvContent = textFromFileLoaded;
          that.parseFile(textFromFileLoaded);
        };

        fileReader.readAsText(fileToRead, 'windows-1252');
      }
    }
    let inputFile: any = document.getElementById('fileInput');
    inputFile.value = '';
  }
}

